import React, { useEffect, useState } from 'react';
import { Row, Col, Card, OverlayTrigger, Spinner, Popover, Button } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';

// compoennts
import SalesReport from './SaleReport';
import SalesReportUSD from './SaleReportUSD';
import OrdersList from './CreditLists';
import { ConvertDay, convertCurrentDate, numberFormat, splitDateTime } from '../../helpers';
import CurrentDateModal from '../../components/currentComponent/CurrentDateModal';
import { COLOR_TEXT, COLOR_WHITE } from '../../constants';

// icons
import { GrMoney, GrThreeD } from "react-icons/gr";
import { IoLogoUsd } from "react-icons/io";
import { MdDateRange } from 'react-icons/md';
import { GET_TRANSACTIONS } from '../../graphql/wallet/query';
import { useLazyQuery } from '@apollo/client';
import PaginationHelper from '../../helpers/PaginationHelper';

const ReportCredits = () => {
    // const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const shopId = localStorage.getItem("SHOP")
    const dateFilterStorageKey = `REPORT_CREDITS_DATE_FILTER::SHOP::${shopId ?? ""}`;
    const dateFilterChangedEventName = "reportCreditsDateFilterChanged";
    // my state
    const [creditDatas, setCreditDatas] = useState({
        data: [],
        chartDatas: [],
        total: 0,
        credited: 0,
        receivedMoney: 0,
    });
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: moment().startOf("month").format("YYYY-MM-DD"),
        createdAt_lt: moment().endOf("month").format("YYYY-MM-DD"),
    });
   
    const [activeButton, setActiveButton] = useState("thisMonth");
    const [isCurrentModals, setIsCurrentModals] = useState(false);


    const [
        getAllTransactions,
        { data: transactionData, loading: loadingTransaction },
    ] = useLazyQuery(GET_TRANSACTIONS, { fetchPolicy: "cache-and-network" });


    // useEffect Hook

    useEffect(() => {
        try {
            if (cdFillter?.createdAt_gte && cdFillter?.createdAt_lt) {
                localStorage.setItem(
                    dateFilterStorageKey,
                    JSON.stringify({
                        createdAt_gte: cdFillter.createdAt_gte,
                        createdAt_lt: cdFillter.createdAt_lt,
                        activeButton,
                    })
                );
            } else {
                localStorage.removeItem(dateFilterStorageKey);
            }
            window.dispatchEvent(new Event(dateFilterChangedEventName));
        } catch (error) {
            console.log(error);
        }
    }, [dateFilterStorageKey, cdFillter?.createdAt_gte, cdFillter?.createdAt_lt, activeButton]);

    useEffect(() => {
        fetchTransactions();
    }, [ cdFillter]);

    useEffect(() => {
        if (transactionData) {
            setCreditDatas({
                data: transactionData?.getAllTransactions?.data,
                total: transactionData?.getAllTransactions?.total,
                credited: transactionData?.getAllTransactions?.reports?.credited,
                receivedMoney: transactionData?.getAllTransactions?.reports?.receivedMoney,
                totalPaidCompleted: transactionData?.getAllTransactions?.reports?.totalPaidCompleted,
                chartDatas: transactionData?.getAllTransactions?.reports?.chartDatas
            });
        }
    }, [transactionData]);


    // function and logic this component
    const fetchTransactions = async () => {
        try {
            let shopId = localStorage.getItem("SHOP");

            if (loadingTransaction) return;
            let _where = {
                shopId: shopId, // "657fbca4741fcb028ebeec3f",
                // status: 'PAYMENT_COMPLETED'
            }

            // // is status
            // if (!_.isEmpty(paymentMethod?.status)) {
            //     _where = {
            //         ..._where,
            //         status: paymentMethod?.status,
            //     }
            // }
            // is current date
            if (!_.isEmpty(cdFillter?.createdAt_gte) && !_.isEmpty(cdFillter?.createdAt_lt)) {
                let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
                let endDateComponents = splitDateTime(cdFillter?.createdAt_lt, true);
                _where = {
                    ..._where,
                    createdAt_gte: startDateComponents,
                    createdAt_lt: endDateComponents,
                }
            }

            await getAllTransactions({
                variables: {
                    where: _where,
                    // skip: (_skip - 1) * _limit,
                    // limit: _limit,
                },
            });
            // setCdFillter({
            //   createdAt_gte: '', createdAt_lt: ''
            // })
        } catch (error) {
            console.log(error);
        }
    };

    // const _newDatasNoClaims = creditDatas?.chartDatas.filter((data) => data?.billStatus !== "APPROVED")
    // const noClaimTotalPrice = _newDatasNoClaims.reduce((total, item) => total + item.amount, 0);
    const LAK_BANKS = ["LDB", "JDB", "BCEL", "APB", "BFL", "INDOCHINA_BANK"];

    // รวมเฉพาะ billStatus !== "APPROVED" ด้วยอยู่แล้ว
    const _newDatasNoClaims = creditDatas?.chartDatas.filter((data) => data?.billStatus !== "APPROVED");
    const noClaimTotalPriceLAK = _newDatasNoClaims
        .filter(item => LAK_BANKS.includes(item?.origin))
        .reduce((total, item) => total + item.amount, 0);

    const noClaimTotalPriceUSD = _newDatasNoClaims
        .filter(item => item.origin === "CREDIT_CARD")
        .reduce((total, item) => total + item.amount, 0);

    // แยกข้อมูลสำหรับแต่ละประเภทเงิน
    const creditDatasLAK = {
        ...creditDatas,
        chartDatas: creditDatas?.chartDatas?.filter(item => LAK_BANKS.includes(item?.origin)),
    };
    const creditDatasUSD = {
        ...creditDatas,
        chartDatas: creditDatas?.chartDatas?.filter(item => item?.origin === 'CREDIT_CARD'),
    };


    return (
        <>
            <div  className="mt-4 mb-2">
                <Button
                    variant="light"
                    onClick={() => setIsCurrentModals(true)}
                    style={{ width: "100%", maxWidth: 230, display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}
                >
                    {loadingTransaction ? (
                        <Spinner size="sm" />
                    ):(
                    <MdDateRange style={{ fontSize: 25, color: COLOR_TEXT }} />
                    )}
                    {cdFillter?.createdAt_gte === "" && cdFillter?.createdAt_lt === "" ? (
                        "mm/dd/yyyy"
                    ) : (
                        <>
                            {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                        </>
                    )}
                </Button>
            </div>
            <Row>
                <Col md={6} style={{ display: 'flex', gap: 10 }}>

                    <Card className="mb-4" style={{ boxShadow: 'none', position: 'relative', width:"100%", height: '100%' }}>
                        <Card.Body  >
                            <Card.Title style={{ fontWeight: 'bold' }}>ຍອດເງິນກີບທີ່ສາມາດເຄມໄດ້</Card.Title>
                            <Card.Text style={{ fontSize: 26, fontWeight: 'bold', color: 'green' }}>₭ {numberFormat(noClaimTotalPriceLAK ?? 0)}</Card.Text>
                        </Card.Body>
                        <div style={{ position: 'absolute', right: 20, bottom: 30 }}>

                            <GrMoney style={{ fontSize: 42, opacity: '0.3', color: 'tomato' }} />

                        </div>
                    </Card>
                    <Card className="mb-4" style={{ boxShadow: 'none', position: 'relative', width:"100%", height: '100%' }}>
                        <Card.Body  >
                            <Card.Title style={{ fontWeight: 'bold' }}>ຍອດເງິນໂດລາທີ່ສາມາດເຄມໄດ້</Card.Title>
                            <Card.Text style={{ fontSize: 26, fontWeight: 'bold', color: 'green' }}>$ {numberFormat(noClaimTotalPriceUSD ?? 0)}</Card.Text>
                        </Card.Body>
                        <div style={{ position: 'absolute', right: 20, bottom: 30 }}>

                            <IoLogoUsd style={{ fontSize: 42, opacity: '0.3'}} />

                        </div>
                    </Card>

                </Col>

                <Col md={6} className='mt-2 mt-md-0'>
                    {/* <Card className="mb-4" style={{ boxShadow: 'none', position: 'relative' }}>
                            <Card.Body>
                                <Card.Title style={{ fontWeight: 'bold' }}>ຍອດເງິນທີ່ເຄມແລ້ວ</Card.Title>
                                <Card.Text style={{ fontSize: 20, fontWeight: 'bold', color: 'black' }}>{numberFormat(_newDatas?.length ?? 0)}</Card.Text>
                                <Card.Text style={{ fontSize: 26,marginTop:'-.85em',  fontWeight: 'bold', color: 'green' }}>₭ {numberFormat(receiveTotalPrice ?? 0)}</Card.Text>
                            </Card.Body>
                            <div style={{ position: 'absolute', right: 20, bottom: 30 }}>

                                <GrThreeD style={{ fontSize: 42, opacity: '0.3', color: 'tomato' }} />

                            </div>
                        </Card> */}
                    <Card className="mb-4" style={{ boxShadow: 'none', position: 'relative',height: '100%' }}>
                        <Card.Body style={{ height: '100%' }}>
                            <Card.Title style={{ fontWeight: 'bold' }}>ອໍເດີ້ທັງໝົດ</Card.Title>
                            <Card.Text style={{ fontSize: 26, fontWeight: 'bold', color: 'green' }}>{numberFormat(_newDatasNoClaims?.length ?? 0)}</Card.Text>
                        </Card.Body>
                        <div style={{ position: 'absolute', right: 20, bottom: 30 }}>

                            <GrThreeD style={{ fontSize: 42, opacity: '0.3', color: 'tomato' }} />

                        </div>
                    </Card>

                </Col>

                {/* <Col md={4}>
                    <OverlayTrigger placement="top" overlay={popoverReceiveTotal}>

                        <Card className="mb-4" style={{ boxShadow: 'none', position: 'relative' }}>
                            <Card.Body>
                                <Card.Title style={{ fontWeight: 'bold' }}>ຍອດເງິນທີ່ໄດ້</Card.Title>
                                <Card.Text style={{ fontSize: 26, fontWeight: 'bold', color: 'green' }}>₭ {numberFormat(creditDatas?.receivedMoney ?? 0)}</Card.Text>
                            </Card.Body>
                            <div style={{ position: 'absolute', right: 20, bottom: 30 }}>

                                <GiTakeMyMoney style={{ fontSize: 48, opacity: '0.6', color: 'green' }} />

                            </div>
                        </Card>
                    </OverlayTrigger>

                </Col> */}
            </Row>

            <Row className="mb-2 mt-4">
                <Col md={6}>
                <p>ສະຖິຕິເງິນກີບ {ConvertDay(activeButton)}</p>
                    <Card style={{ boxShadow: 'none', background: COLOR_WHITE }}>
                        <SalesReport creditDatas={creditDatasLAK} />
                    </Card>
                </Col>
                <Col md={6} className="mt-3 mt-md-0">
                <p>ສະຖິຕິເງິນໂດລາ {ConvertDay(activeButton)}</p>
                    <Card style={{ boxShadow: 'none', background: COLOR_WHITE }}>
                        <SalesReportUSD creditDatas={creditDatasUSD} />
                    </Card>
                </Col>
            </Row>


            {/* modal current date  */}
            <CurrentDateModal
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
                backdrop={true}
            />
        </>
    );
};

export default ReportCredits;

